import { useMutationStatusToast } from 'hooks';
import { useField } from 'react-final-form';
import { useFetchAiPreviewMutation } from 'services/api/vehicle-sections';

type AfterSave = (value: string | null, field?: string) => void | Promise<void>;

export const useAiCommentAction = (fieldId: string, afterSave?: AfterSave) => {
  const {
    input: { value: status, onChange: setStatus }
  } = useField<'ai_fetched' | 'ai_used' | null>(`${fieldId}.status`, { subscription: { value: true } });

  const {
    input: { value: message, onChange: setMessage }
  } = useField<string | null>(`${fieldId}.message`, { subscription: { value: true } });

  const {
    input: { value: aiMessage, onChange: setAiMessage }
  } = useField<string | null>(`${fieldId}.ai_message`, { subscription: { value: true } });

  const {
    input: { onChange: setOgMessage }
  } = useField<string | null>(`${fieldId}.original_message`);

  const [fetchAiPreview] = useFetchAiPreviewMutation();

  const statusToast = useMutationStatusToast({
    loading: 'Generating AI message...',
    success: 'Success',
    error: 'Failed to generate AI message'
  });

  const applyAiComment = () => {
    setStatus('ai_used');
    setOgMessage(message);
    setMessage(aiMessage);

    if (afterSave) {
      afterSave('ai_used', 'status');
      afterSave(message, 'original_message');
      afterSave(aiMessage, 'notes');
    }
  };

  const fetchAiComment = async () => {
    console.log(message, 'fetchAiMessage');
    if (!message) return;

    const fetchedAiMessagePromise = fetchAiPreview(message);
    statusToast(fetchedAiMessagePromise);
    const fetchedAiMessage = await fetchedAiMessagePromise;
    if ('data' in fetchedAiMessage) {
      setStatus('ai_fetched');
      setAiMessage(fetchedAiMessage.data);

      if (afterSave) {
        afterSave('ai_fetched', 'status');
        afterSave(fetchedAiMessage.data, 'ai_message');
      }
    }
  };

  const buttonLabel = status === 'ai_fetched' ? 'Use' : 'Ai Recommend';
  const buttonColor = status === 'ai_fetched' ? '#3994de' : '#225A91';

  const action = status === 'ai_fetched' ? applyAiComment : fetchAiComment;

  return { buttonLabel, buttonColor, action, status };
};
